import { useState, useEffect } from 'react'
import { SignInButton, UserButton, useUser } from '@clerk/react'
import { Link } from 'react-router-dom'

interface NavbarProps {
  onMenuClick?: () => void
}

export default function Navbar({ onMenuClick }: NavbarProps) {
  const { isSignedIn, isLoaded } = useUser()
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const isMobile = windowWidth < 768

  return (
    <nav
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'var(--green)',
        height: 'var(--nav-height)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: isMobile ? '0 16px' : '0 28px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
      }}
    >
      {/* Left side - hamburger on mobile */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {isMobile && isSignedIn && (
          <button
            onClick={onMenuClick}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: 24,
              cursor: 'pointer',
              padding: '8px 12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 'var(--radius)',
              transition: 'background 0.15s',
              height: 44,
              width: 44,
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = 'rgba(255,255,255,0.1)')
            }
            onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
            aria-label="Toggle menu"
            title="Open menu"
          >
            ☰
          </button>
        )}
      </div>

      {/* Right side */}
      {isLoaded && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {isSignedIn && (
            <Link
              to="/settings/pricing"
              style={{
                color: 'rgba(255,255,255,0.75)',
                fontSize: 13,
                fontWeight: 500,
                textDecoration: 'none',
                padding: '4px 8px',
                borderRadius: 5,
                transition: 'color 0.15s',
              }}
              onMouseEnter={(e) => ((e.currentTarget as HTMLElement).style.color = '#fff')}
              onMouseLeave={(e) => ((e.currentTarget as HTMLElement).style.color = 'rgba(255,255,255,0.75)')}
            >
              Pricing
            </Link>
          )}
          {isSignedIn ? (
            <UserButton
              appearance={{
                elements: {
                  avatarBox: { width: 34, height: 34 },
                },
              }}
            />
          ) : (
            <SignInButton mode="modal">
              <button
                style={{
                  background: 'rgba(255,255,255,0.12)',
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.28)',
                  padding: '7px 18px',
                  borderRadius: 'var(--radius)',
                  fontSize: 14,
                  fontWeight: 500,
                  letterSpacing: '0.01em',
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = 'rgba(255,255,255,0.22)')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = 'rgba(255,255,255,0.12)')
                }
              >
                Sign in
              </button>
            </SignInButton>
          )}
        </div>
      )}
    </nav>
  )
}
